<template lang='pug'>
  div
    EditTindakanClosing( 
      ref="showModalEditTindakan"  
    )
    v-row( 
      no-gutters 
      v-if="dataClosing.ipTingkatRisikoSetelahPerubahan && dataClosing.ipTingkatRisikoSetelahPerubahan.tingkatRisiko <= 4"
    )
        v-col(sm="12" xs="12") 
          h3(class="headSectionPeriksa") Deskripsi Penyelesaian 
       
        v-col(style="margin-left:38px" sm="11" xs="11") 
          ckeditor(:editor="editor" v-model="description" :config="editorConfig")

    v-row(
      no-gutters 
      style="margin-top:30px" 
      v-if="dataClosing.ipTingkatRisikoSetelahPerubahan && dataClosing.ipTingkatRisikoSetelahPerubahan.tingkatRisiko >= 5 "
    )
        v-col(sm="12" xs="12") 
          span(class="headSectionPeriksa mustFill" style="margin-right:-13px;") *
          span(style="font-style: italic;font-size:12px") Silahkan lakukan tindakan lanjut perubahan dengan cara close semua status jika sudah dikerjakan

        v-col(sm="12" xs="12")
          v-data-table( 
            :headers="headers"
            :items="dataClosing.ipTindakanPengendalian"
            :must-sort="true"
            :single-expand="true"
            hide-default-footer
            class="elevation-1"
            style="margin-left:38px;margin-top:15px;margin-bottom:15px"
          )
            template(v-slot:item.statusTindakan="{ item }")
              v-chip( 
                labe
                small
                :color="statusColor[item.statusTindakan].color"
                style="width: 100%; justify-content: space-evenly"
                text-color="black" 
              ) {{ item.statusTindakan }}

            template(v-slot:item.actions="{ item}")
              v-btn(icon color="orange" @click="showModalEdit(item)")
                v-icon( 
                  small
                  style="color: orange"
                ) mdi-pencil 

            template(slot="no-data")
              img(
                src="../assets/plus-circle.png" 
                style="width:7%;margin-top:20px"
              )
              p Belum ada tindakan, Silahkan tambah
              p(style="margin-top:-17px;margin-bottom:20px") tindakan terlebih dahulu

            <br/>

        v-col(sm="12" xs="12")
          img(
            class="headSectionPeriksa" 
            src="../assets/table_matriks.png" 
            style="width:70%;margin-left:18px"
          )

        v-col(sm="12" xs="12")
           h3(class="headSectionPeriksa") Tingkat Resiko Setelah Dikendalikan 
      
        v-col(sm="3" xs="3")
          span(class="headSectionPeriksa") Nilai Konsekuensi
          v-autocomplete(
            class="inputDefault"
            v-model="konsekAwal"
            style="margin-top:10px; margin-left:38px;"
            :items="dataNilai"
            item-value="value"
            item-text="label"
            solo
            label="Pilih"
          )
          
        v-col(sm="3" xs="3")
          span(class="headSectionPeriksa") Kekerapan / Kemungkinan
          v-autocomplete(
            class="inputDefault"
            v-model="kekerapanAwal"
            style="margin-top:10px; margin-left:38px;"
            :items="dataNilaiKekerapan"
            item-value="value"
            item-text="label"
            solo
            label="Pilih"
          )

        v-col(
          sm="3" 
          xs="3"
        )
          span(
            class="headSectionPeriksa") Tingkat Resiko
          v-text-field(
            style="margin-left:38px;margin-top:10px" 
            type="number" 
            v-model="tngktResikoAwal" 
            class="inputDefault" 
            solo-inverted disabled
          )

         

    //- v-row(
    //-   no-gutters  
    //-   v-for="item of questionData" 
    //-   :key="item.questionId"
    //- )
    //-   v-col(sm="9" xs="9") 
    //-     p(class="headerInputPeriksa") {{item.question}} 
  
    //-   v-col(sm="2" xs="2") 
    //-     v-select(
    //-       class="selectInput" 
    //-       :items='checkOptions' 
    //-       v-model="item.answer" 
    //-       label="Pilih" 
    //-       clearable
    //-     )

    v-row
      v-col(sm="1" style='margin-left:40px')
        v-btn(
          color="blue-grey"  
          @click='handleBack()' 
          block 
          style='color:white'
        ) Back 

      v-col(
        sm="1" 
        style='margin-left:40px'
      )

        v-btn(
          color='success' 
          style='margin-left:-50px' 
          @click='submitPenyelesaian' 
          block 
          :disabled='!isFormValid'
          v-if="dataClosing.ipTingkatRisikoSetelahPerubahan && dataClosing.ipTingkatRisikoSetelahPerubahan.tingkatRisiko <= 4"
        )
          v-icon send
          | Submit 

        v-btn(
          color='success' 
          style='margin-left:-50px' 
          @click='handleSubmit()' 
          :disabled="!isFormResikoTinggiValid"
          block 
          v-else
        )
          v-icon send
          | Submit 

</template>

<script>
import axios from "axios";
import * as config from "../config/index.json";
import EditTindakanClosing from "./usulan-perubahan/EditTindakanClosing.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import { mapState} from "vuex";

export default {
  name: "PenyelesaianUsulan",
  components: {
    EditTindakanClosing
  },
  props: [],
  data() {
    return {
        editor: ClassicEditor,
        statusColor :{
          "OPEN" :{
            color : "#E4E83D"
          },
          "CONTINUE" :{
            color : "#4CAF50"
          },
          "CLOSE" :{
            color : "red"
          }
        },
        editorConfig: {
            extraPlugins: [MyCustomUploadAdapterPlugin],
            removePlugins: ["ImageUpload", "MediaEmbed"],
            toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
            image: {
                // You need to configure the image toolbar, too, so it uses the new style buttons.
                toolbar: [
                "imageTextAlternative",
                "|",
                "imageStyle:alignLeft",
                "imageStyle:full",
                "imageStyle:alignRight",
                ],
                styles: [
                // This option is equal to a situation where no style is applied.
                "full",
                // This represents an image aligned to the left.
                "alignLeft",
                // This represents an image aligned to the right.
                "alignRight",
                ],
            },
        },
      konsekAwal:"",
      kekerapanAwal:"",
      tngktResikoAwal:"",
      headers: [
        {
          text: 'Nama Tindakan',
          align: 'start',
          sortable: false,
          width:"600px",
          value: 'titleTindakan',
        },
        { text: 'Tanggal', sortable: false, value: 'deadline' },
        { text: 'Oleh', sortable: false, value: 'penanggungJawab.name' },
        { text: 'Status',width:"100px", sortable: false, value: 'statusTindakan' },
        { text: 'Action', sortable: false, value: 'actions' }
      ],
      docPelaporan: null,
      disableSubmit : true,
      uploadId : "",
      questionData :[],
      dataFormCode: "",
      dataClosing:{},
      rules: [
        (value) =>
          !value || value.size < 10000000 || "Ukuran file harus dibawah 10 MB!",
      ],
      checkOptions: ["Ya", "Tidak"],
      description: null,
      dataNilai: config.dataNilai,
      dataNilaiKekerapan: config.dataNilaiKekerapan
    };
  },
  computed: {
    ...mapState(["API_URL", "dataQuestions","formIdQuestion","formCodeQuestions","PayloadQuestion"]),
    isFormValid() {
      return (
        this.description
      )
    },
    isFormResikoTinggiValid() {
      return (
        this.tngktResikoAwal && this.dataClosing.ipTindakanPengendalian.every((item) => item.statusTindakan == 'CLOSE' && item.lampiranUploadId && item.description )
      )
    }
  },
  mounted () {
    this.dataFormCode = this.$route.params.formCode;
    this.getPreview(this.$route.params.permitId)
  },
  methods: {
    getPreview(id) {
        axios.get(
          `${this.$store.state.API_URL}/v1/requests/getById/` + id, 
          {
            headers: {"Authorization": `Bearer ${this.$store.state.token}`}
          }
        ).then(res => {
          this.dataClosing = res.data[0]
        })
        .catch(err => {
          console.log(err) 
        })
    },
    // deleteDocPelaporan(name) {
    //   let id = this.uploadId;
    //   axios.get(`${this.API_URL}/v1/requests/attachment/${name}/delete/${id}`, {
    //       headers: { Authorization: `Bearer ${this.$store.state.token}` },
    //     })
    //     .then(() => {
    //       this.uploadId = null
    //       this.docPelaporan = null;
    //     });
    // },
    handleBack(){
      this.$router.push("/my-permit");
    },
    handleSubmit(){
      this.$store
        .dispatch("perubahanClosing", {
          formId: this.dataClosing._id,
          ipTindakanPengendalian: this.dataClosing.ipTindakanPengendalian,
          nilaiKonsekuensi: this.konsekAwal,
          kekerapan: this.kekerapanAwal,
          tingkatRisiko: this.tngktResikoAwal
        })
        .then((res) => {
          if(res.status == 200){
            this.$router.push("/my-permit");
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
    submitPenyelesaian() {
      axios.post(
        `${this.API_URL}/v1/requests/perubahan/closing`, {
          "formId": this.dataClosing._id,
          "ipDeskripsiPenyelesaian": this.description
        },
        { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
      )
      .then((res)=>{
        if(res.status == 200){
          this.$router.push("/my-permit");
        }
      })
      .catch((err)=>{
        console.log(err)
      })
    },
    showModalEdit(item) {
      this.$refs.showModalEditTindakan.showModal(item);
    }
  },
  watch: {
    docPelaporan(params) {
      if (params && params.size < 10000000) {
        this.uploadId = Date.now();
        let formData = new FormData();
        formData.append("uploadId", this.uploadId);
        formData.append("docPendukung", params);
        this.uploadId ? this.disableSubmit = false : this.disableSubmit = true;
        axios.post(
          `${this.API_URL}/v1/requests/attachment/docPendukung`,
          formData,
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
        );
      }
    },
    uploadId(param){
       if(param === null){
        this.disableSubmit = true
       }
    },
    kekerapanAwal(val){
      this.tngktResikoAwal = this.konsekAwal * val 
    },
    konsekAwal(val){
      this.tngktResikoAwal = val * this.kekerapanAwal 
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>